module.exports = __webpack_public_path__ + "img/home_top_img.db115c2b.jpg";